export default "__VITE_ASSET__D_QPG4yL__"